import {
  productListBlueprint,
  productListHeaderMontevideoBlueprint,
} from "@made-people/blueprint-product-list/blueprint";

productListHeaderMontevideoBlueprint.override({
  slots: {
    base: "grid grid-cols-1 grid-rows-[auto_auto] lg:flex items-end w-full col-span-full rounded-md transition-shadow",
    filterTrigger:
      "text-body-md gap-2 flex items-center cursor-pointer w-fit border border-black rounded-md w-fit px-4 py-2 hover:bg-black/10 transition-colors duration-200 ease-in-out col-start-1 col-end-2 row-start-1 row-end-2",
    filterTriggerIcon: "w-4 h-4",
    activeFilters:
      "flex flex-wrap gap-3 lg:gap-2 empty:hidden pt-6 lg:pt-0 lg:pl-6 col-start-1 col-end-2 row-start-2 row-end-3",
    headerProducts:
      "text-body-md text-text-less-emphasis-1 w-fit text-right ml-auto row-start-1 col-start-1 col-end-3 row-end-2",
  },
});

productListBlueprint.override({
  slots: {
    base: "",
    grid: "grid grid-cols-2 grid-rows-[auto_1fr] lg:grid-cols-4 gap-component-spacing-sm lg:gap-component-spacing-xl transition-all",
    list: "grid col-span-full row-span-2 grid-cols-subgrid gap-[inherit] auto-rows-max grid-flow-dense",
    filter: "hidden lg:block row-start-2",
    item: "group/list-item",
    loadMore: "col-span-full",
    descriptionWrapper:
      "grid grid-cols-2 gap-component-spacing-sm lg:gap-component-spacing-xl lg:grid-cols-4 xl:grid-cols-5 2xl:grid-cols-6 *:col-span-full lg:*:col-start-2 lg:*:col-end-[-2] mt-4 mb-8 lg:mt-6 lg:mb-12 xl:mt-10 xl:mb-16",
    description: "",
    linkBelowList:
      "flex items-center gap-2 text-body-sm col-start-1 lg:col-start-2 col-end-4 justify-self-center",
  },
  variants: {
    columns: {
      "1": { grid: "grid-cols-1" },
      "2": { grid: "grid-cols-2" },
      "3": { grid: "grid-cols-3" },
      "4": { grid: "grid-cols-4" },
      "5": { grid: "grid-cols-5" },
      "6": { grid: "grid-cols-6" },
      "7": { grid: "grid-cols-7" },
      "8": { grid: "grid-cols-8" },
      "9": { grid: "grid-cols-9" },
      "10": { grid: "grid-cols-10" },
      "11": { grid: "grid-cols-11" },
      "12": { grid: "grid-cols-12" },
    },
    columnSpan: {
      "1": { item: "col-span-1" },
      "2": { item: "col-span-2" },
      "3": { item: "col-span-3" },
      "4": { item: "col-span-4" },
      "5": { item: "col-span-5" },
      full: { item: "col-span-full" },
    },
    rowSpan: {
      "1": { item: "row-span-1" },
      "2": { item: "row-span-2" },
      "3": { item: "row-span-3" },
      "4": { item: "row-span-4" },
      "5": { item: "row-span-5" },
      full: { item: "row-span-full" },
    },
  },
});
